<template>
    <Navbar></Navbar>
    <div class="product-detail-page">
        <div class="detail-banner">
            <div class="img-box detail-banner-img">
                <img src="/assets/product/transmission/240kW/240kW.jpg" alt="200-1-01">
            </div>
            <div class="detail-banner-r">
                
                <div class="detail-banner-t2">240kW两挡三合一电驱总成</div>
                <div class="detail-banner-desc transmission">800V两挡高承载三合一电驱总成，集成升压快充功能
                    <div class="detail-desc">
                        <div>
                            三合一大功率电桥，集成差速锁、升压充电、直充功能，最大升压充电功率高达120kW，提升整车充电速率；<br />
                        </div>
                        <div>
                            电机采用水冷+油冷复合冷却，散热能力提升25%，提升电机持续输出能力；<br />
                        </div>
                        <div>
                            首搭自研1200V碳化硅模块，加持超薄硅钢片、分段磁钢设计、主动可调润滑系统，提升整箱效率。
                        </div>

                    </div>
                </div>
            </div>
        </div>

        <div class="detail-center">
            <div class="detail-center-l">
                <!-- <div class="detail-text-box">
                    <div class="detail-title">产品说明</div>

                    <div class="detail-desc">
                        <div>
                            三合一大功率电桥，集成差速锁、升压充电、直充功能，最大升压充电功率高达120kW，提升整车充电速率<br />
                        </div>
                        <div>
                            电机采用水冷+油冷复合冷却，散热能力提升25%，提升电机持续输出能力<br />
                        </div>
                        <div>
                            首搭自研1200V碳化硅模块，加持超薄硅钢片、分段磁钢设计、主动可调润滑系统，提升整箱效率
                        </div>

                    </div>
                </div> -->

                <div class="one-titile">
                    核心配置
                </div>
                <div class="spec-row">
                    <div class="spec-image img-box">
                        <img src="/assets/product/transmission/240kW/240kW-1.jpg" alt="200-1-02">
                    </div>
                    <div class="spec-card">
                        <div class="spec-columns">
                            <div class="spec-title">
                                产品参数
                            </div>
                            <div class="spec-col">
                                <div class="spec-item">
                                    <div class="v">240kW</div>
                                    <div class="k">电机峰值功率</div>
                                </div>
                                <div class="spec-item">
                                    <div class="v">18000rpm</div>
                                    <div class="k">电机峰值转速</div>
                                </div>
                                <div class="spec-item">
                                    <div class="v">8500N·m</div>
                                    <div class="k">最大轮端扭矩</div>
                                </div>
                                <div class="spec-item">
                                    <div class="v">水冷+油冷</div>
                                    <div class="k">电机冷却</div>
                                </div>
                                <div class="spec-item">
                                    <div class="v">2</div>
                                    <div class="k">挡位数量</div>
                                </div>
                                <div class="spec-item">
                                    <div class="v">550*600*437</div>
                                    <div class="k">尺寸 X*Y*Z（mm）</div>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    </div>
    <Footer></Footer>
</template>

<script setup>
import Navbar from '@/components/Navbar.vue';
import Footer from '@/components/Footer.vue';
</script>

<script>
export const pageConfig = {
    title: '240kW两挡三合一电驱总成 - 蜂巢汽车官网',
    keywords: '蜂巢,蜂巢汽车,发动机,变速器,电子',
    description: '蜂巢汽车科技集团有限公司，是一家掌握从传统动力到混合动力再到纯电动力（含控制器）全领域动力总成、汽车智能化集成系统等核心技术的零部件企业，具备完整的软、硬件产业链；能为客户提供高效节能环保的汽车动力总成、智能化出行解决方案',
    outputPath: 'transmission/240.html'
};

import { createApp } from 'vue';
import App from './240.vue';
import store from '@/store/index';
import "@/assets/styles/global.scss";
import "@/assets/styles/transmission-200.scss";

function mountApp() {
    const appNode = document.getElementById('app');
    if (appNode) {
        if (appNode._vueApp) {
            appNode._vueApp.unmount();
            delete appNode._vueApp;
        }
        const app = createApp(App);
        app.use(store);
        appNode._vueApp = app.mount(appNode);
    }
}

document.addEventListener('DOMContentLoaded', mountApp);

if (module.hot) {
    module.hot.accept('./240.vue', () => {
        mountApp();
    });
}
</script>

<style lang="scss" scoped></style>
